'use client';

import { HOME_PATH } from '@/constants/paths';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Link from 'next/link';
import useTranslations from '@/hooks/useTranslations';

interface Props {
  iframe?: boolean;
}

export default function NotFound({ iframe }: Props) {
  const { t, locale } = useTranslations();

  const buttonProps = iframe
    ? { onClick: () => window.top?.location.assign(`${HOME_PATH}${locale}`) }
    : { LinkComponent: Link, href: HOME_PATH };

  return (
    <Container maxWidth='sm'>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          minHeight: '100vh',
          textAlign: 'center',
          gap: 2,
        }}
      >
        <Typography
          variant='h1'
          component='h1'
          sx={{ fontSize: '6rem', fontWeight: 'bold', color: 'primary.main' }}
        >
          {t('errors.notFound.title')}
        </Typography>
        <Typography variant='h4' component='h2' sx={{ mb: 2 }}>
          {t('errors.notFound.subtitle')}
        </Typography>
        <Typography variant='body1' color='text.secondary' sx={{ mb: 4 }}>
          {t('errors.notFound.description')}
        </Typography>
        <Button {...buttonProps} variant='contained' size='large' sx={{ borderRadius: 2 }}>
          {t('errors.notFound.action')}
        </Button>
      </Box>
    </Container>
  );
}
